import {
  Box,
  Container,
  Grid,
  GridItem,
  Image,
  Heading,
  Text,
  HStack,
} from "@chakra-ui/react";
import React from "react";

import FlowerIcon from "../../../assets/home/flower.png";
import chat from "../../../assets/about/apart/chat.png";
import roi from "../../../assets/about/apart/roi.png";
import situted from "../../../assets/about/apart/situted.png";
import success from "../../../assets/about/apart/success.png";
import about5 from "../../../assets/about/about5.png";
import growth from "../../../assets/about/25growth.png";
import about7 from "../../../assets/about/about7.png";
import about2 from "../../../assets/about/about2.png";
import clientsatisfaction from "../../../assets/about/apart/clientsatisfication.png";
import cream from "../../../assets/flower/cream.png";
import grey from "../../../assets/flower/greyish.png";
import grey1 from "../../../assets/flower/greyish.png";
import grey2 from "../../../assets/flower/greyish.png";
import FlowerImage from "component/FlowerImage";

const Apart = () => {
  return (
    <Box py={12} position="relative" color="black">
      <FlowerImage
        src={cream}
        top={{ base: "60%", md: "60%" }}
        right={{ base: "40%", md: "47%" }}
      />
      <FlowerImage
        src={grey}
        top={{ base: "43%", md: "54%" }}
        left={{ base: "50%", md: "40%" }}
      />
      <FlowerImage
        src={grey1}
        top={{ base: "57%", md: "73%" }}
        right={{ base: "80%", md: "65%" }}
      />
      <FlowerImage
        src={grey2}
        top={{ base: "71%", md: "83%" }}
        left={{ base: "30%", md: "50%" }}
      />
      {/* Heading Section - Centered Text with Right Image */}
      <Container maxW="container.lg" mb={8}>
        <HStack
          justifyContent="center"
          alignItems="center"
          spacing={0}
          textAlign="center"
          
          position="relative"
          zIndex={2}
          pb={{ base: 4, md: 16 }}
        >
          <Box textAlign="center" position="relative">
            {/* Flower image behind heading */}
            <Image
              src={FlowerIcon}
              alt="Flower"
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              boxSize={{ base: "150px", md: "170px" }}
              opacity={1}
              zIndex={0}
            />
            <Box
              display={"flex"}
              width={{base:'100%',md:'600px'}}
              justifyContent="flex-end"
              alignItems="center"
              mb={4}
              flexDirection={{base:'column',md:'row'}}
            >

              <Heading
                as="h2"
                fontSize={{ base: "2xl", md: "4xl" }}
                fontWeight="bold"
                zIndex={1}
                position="relative"
                className="fade-in-up"
              >
                What Sets Us{" "}
                <Text
                  as="span"
                  fontStyle="italic"
                  color="#BFA585"
                  className="fade-in-up"
                >
                  Apart
                </Text>
                ,
              </Heading>
              <Image src={growth} alt="Services Tag" maxW="150px" display={{base:'none',md:'block'}} />
            </Box>
          </Box>
        </HStack>

        {/* Top Image Row */}
        <Box
          display={{ base: "flex", md: "flex" }}
          gap={4}
          flexDirection={{ base: "column", md: "row" }}
          mt={8}
        >
          <Image
            src={about5}
            width={{ base: "100%", md: "50%" }}
            alt="brandswork"
            className="fade-in-up"
          />
          <Image
            src={situted}
            width={{ base: "100%", md: "50%" }}
            position="relative"
            top={{ base: "-19px", md: "0" }}
            height={{ base: "auto", md: "20%" }}
            alt="brandswork"
            className="fade-in-up"
          />
        </Box>

        {/* Grid Columns */}
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
          gap={8}
          mt={8}
          textAlign="left"
        >
          {/* Column 1 - Stats */}
          <GridItem>
            <Image src={about7} alt="Stats" mb={4} className="fade-in-up" />
            <Box bg="white" borderRadius="20px" boxShadow="2xl" p={12} mb={4}>
              <Heading fontSize="xl" fontWeight="bold">
                200+
              </Heading>
              <Text>Client Served</Text>
            </Box>
          </GridItem>

          {/* Column 2 - About2 and Success with Overlay Text */}
          <GridItem display="flex" flexDirection="column" gap={6}>
            <Box position="relative" borderRadius="12px" overflow="hidden">
              <Image
                src={about2}
                alt="About2"
                width="100%"
                className="fade-in-up"
              />
              <Box
                position="absolute"
                top="0"
                left="0"
                w="100%"
                h="100%"
                color="white"
                px={6}
                py={8}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Text fontSize="sm" fontWeight="bold" className="fade-in-up">
                  DEDICATION
                </Text>
                <Box>
                  <Heading
                    fontSize="lg"
                    fontWeight="bold"
                    className="fade-in-up"
                  >
                    A commitment to storytelling that connects.
                  </Heading>
                </Box>
              </Box>
            </Box>

            <Box position="relative" borderRadius="12px" overflow="hidden">
              <Image src={success} alt="Success" width="100%" />
              <Box
                position="absolute"
                top="0"
                left="0"
                w="100%"
                h="100%"
                bg="rgba(0,0,0,0.4)"
                color="white"
                px={6}
                py={8}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Text fontSize="sm" fontWeight="bold" className="fade-in-up">
                  SUCCESS
                </Text>
                <Box>
                  <Heading
                    fontSize="lg"
                    fontWeight="bold"
                    className="fade-in-up"
                  >
                    An unwavering dedication to your success.
                  </Heading>
                </Box>
              </Box>
            </Box>
          </GridItem>

          {/* Column 3 - Reviews and Satisfaction */}
          <GridItem>
            <HStack justifyContent="center">
              <Image
                src={clientsatisfaction}
                alt="Satisfaction"
                mb={4}
                width="150px"
              />
              <Image src={roi} alt="ROI" mb={8} width="150px" />
            </HStack>
            <Image src={chat} alt="Chat" mb={4} />
            <Box bg="white" borderRadius="20px" boxShadow="2xl" p={12} mb={4}>
              <Heading fontSize="xl" fontWeight="bold">
                ☆☆☆☆☆
              </Heading>
              <Text>5.0/5 Based on 256 reviews</Text>
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
};

export default Apart;
